export default __webpack_public_path__ + "static/media/Store.13e60912.jpg";